import { isStringEnumValue } from 'utils';
import {
  SelfOnboardingStepKey,
  LanguageOption,
  SelfOnboardingNavigationStepKey,
} from './types';
import { SequentialStep } from './helpers/useSelfOnboardingNavigation.config';

export const languageOptions: LanguageOption[] = [
  { label: 'English', value: 'en' },
  { label: 'Spanish', value: 'es' },
  { label: 'Chinese (Simplified)', value: 'zhCN' },
  { label: 'Chinese (Traditional)', value: 'zhTW' },
  { label: 'Hungarian', value: 'hu' },
  { label: 'Polish', value: 'pl' },
  { label: 'Russian', value: 'ru' },
  { label: 'Turkish', value: 'tr' },
];

export const defaultStep = SelfOnboardingStepKey.LanguageSelection;
export const defaultLanguage = languageOptions[0];

export const resolveSelfOnboardingStep = (
  step: string,
  visibleSequentialSteps: SequentialStep[],
): {
  currentStep: SelfOnboardingNavigationStepKey;
  currentConfigStep: SelfOnboardingStepKey;
} => {
  if (isStringEnumValue(SelfOnboardingStepKey, step)) {
    return { currentStep: step, currentConfigStep: step };
  }
  const foundStep = visibleSequentialSteps.find(
    (s): s is Extract<SequentialStep, { key: string }> =>
      typeof s === 'object' && s.key === step,
  );
  return foundStep
    ? {
        currentStep: foundStep.key,
        currentConfigStep: foundStep.workerDocTypeKey,
      }
    : { currentStep: defaultStep, currentConfigStep: defaultStep };
};

export const getBaseRoute = (jobsiteInvitationId: string): string =>
  `/self-onboarding/${jobsiteInvitationId}`;

export const generateSelfOnboardingInvitationLink = (
  jobsiteInvitationId: string,
): string => {
  if (!jobsiteInvitationId) return null;
  const { protocol, hostname, port } = window.location;
  return `${protocol}//${hostname}${
    port ? `:${port}` : ''
  }/self-onboarding/${jobsiteInvitationId}`;
};
